import { create } from 'zustand';
import { combine, persist } from 'zustand/middleware';

/*
 * 리모트 디버거 상태를 관리하는 store
 */
export const useRemoteDebuggerStore = create(
  persist(
    combine(
      {
        enabled: false,
        useDebugLog: false,
      },
      (set, get) => ({
        toggle: () => set({ enabled: !get().enabled }),
        enable: () => set({ enabled: true }),
        disable: () => set({ enabled: false }),
        toggleDebugLog: () => set({ useDebugLog: !get().useDebugLog }),
        enableDebugLog: () => set({ useDebugLog: true }),
        disableDebugLog: () => set({ useDebugLog: false }),
      }),
    ),
    {
      name: 'ks-remote-debugger',
    },
  ),
);
